<template>
  <div id="app">

    <router-view></router-view>

    <!-- Modales y notificaciones globales -->
    <modern-loader v-if="processing && $route.name !== 'finalizar-nivel'" :message="blockMessage" :show="processing" />
    <modern-loader v-if="error" :message="error" :show="!!error" />
    <modern-loader v-if="warning" :message="warning" :show="!!warning" />

    <!-- Modal de Error -->
    <b-modal v-if="modal_error" no-close-on-backdrop no-close-on-esc title="Atención" ok-only v-model="show_modal_error"
      id="modalError" ok-title="Cerrar" @ok="reiniciarModalError()" modal-class="modal-modern">
      <div class="text-center">
        <p v-html="modal_error"></p>
      </div>
    </b-modal>

    <!-- Modal de actualización de la aplicación -->
    <b-modal no-close-on-backdrop no-close-on-esc hide-header hide-footer ok-only v-model="updateExists"
      id="modalupgrading" modal-class="modal-modern">
      <div class="text-center update-content">
        <div class="update-icon"> <i class="ri-loop-right-line"></i> </div>
        <h5>Nueva versión disponible</h5>
        <p>Encontramos una nueva versión de la aplicación. Es necesario actualizar para continuar.</p>
        <b-button variant="primary" @click="refreshApp" class="btn-update">
          <i class="ri-loop-right-line"></i> Actualizar ahora
        </b-button>
      </div>
    </b-modal>


    <!-- b-modal v-if="!updateExists && maintenance && maintenance.enable" no-close-on-backdrop no-close-on-esc hide-header hide-footer 
    v-model="maintenance.enable"  id="modalMaintence" >
      <div class="text-center">
        <h5>{{maintenance.message}}</h5>
      </div>
    </b-modal-->

    <!--MODAL PARA BANNERS PUBLICIDAD-->
    <b-modal hide-footer hide-header ok-only v-model="bannerDialogShowed" id="modalBanners" title=""
      modal-class="modal-modern modal-banner">
      <div v-if="ultimo_banner" class="banner-content">
        <button class="btn-close-banner" @click="bannerDialogShowed = false">
          <i class="ri-close-line"></i>
        </button>

        <a v-if="ultimo_banner.destination_url" :href="ultimo_banner.destination_url" target="_blank"
          class="banner-image-link">
          <b-img fluid-grow :src="ultimo_banner.url" class="banner-image"></b-img>
        </a>
        <b-img v-else fluid-grow :src="ultimo_banner.url" class="banner-image"></b-img>

        <div v-if="ultimo_banner.destination_url" class="banner-footer">
          <b-link :href="ultimo_banner.destination_url" target="_blank" class="btn-banner-info">
            <i class="ri-information-line"></i>
            Más información
          </b-link>
        </div>
      </div>
    </b-modal>

    <!-- Mensajes Modernos -->
    <transition-group name="alert-slide" tag="div" class="modern-alerts-container"
      :class="{ 'alerts-hidden': recorridoActivo }">
      <div v-for="(mensaje, index) in mensajes" :key="mensaje._id || `mensaje-${index}`" class="modern-alert"
        :class="`alert-${mensaje.variant}`">
        <div class="alert-icon">
          <i v-if="mensaje.variant === 'success'" class="ri-checkbox-circle-line"></i>
          <i v-else-if="mensaje.variant === 'danger'" class="ri-close-circle-line"></i>
          <i v-else-if="mensaje.variant === 'warning'" class="ri-error-warning-line"></i>
          <i v-else class="ri-information-line"></i>
        </div>
        <div class="alert-content" v-html="mensaje.html"></div>
        <button class="alert-close" @click="dismissMensaje(index)">
          <i class="ri-close-line"></i>
        </button>
      </div>
    </transition-group>

    <!-- WhatsApp flotante -->
    <whats-app-button></whats-app-button>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import WhatsAppButton from '@/components/Sections/WhatsAppButton.vue';
import ModernLoader from '@/components/Sections/ModernLoader.vue';

export default {
  name: 'app',
  components: {
    WhatsAppButton,
    ModernLoader
  },
  data() {
    return {
      blockMessage: 'Procesando...',
      registration: null,
      updateExists: false,
      bannerPending: false,
      bannerDisplayTimer: null,
      processedMessageIds: new Set(), // Rastrear mensajes ya procesados
    }
  },
  mounted() {
    this.buscarClaseActual()

    if (this.logged) {
      this.verificarAceptacionTerminos()
      this.verificarMensajes()
      this.verificarVariables()

      this.fetchTipos() //Cachear
      this.fetchSedes() //Cachear

      this.fetchCursoActual() //Empaquetar
      this.fetchSedeActual() //Empaquetar

      this.fetchBanners()
        .then((result) => {
          if (result && result.length > 0) {
            this.requestBannerDisplay()
          }
        })
    }

    // Escuchar evento para recargar notificaciones
    this.$root.$on('reload-notifications', this.onReloadNotifications)
    // Login pide mostrar el banner por aquí para respetar las condiciones de bannerBlocked
    this.$root.$on('request-banner-display', this.requestBannerDisplay)

    /*
      En celulares no funciona si la app esta oculta
      Debe optimizarse enviando mensajes desde el servidor a la hora adecuada
      Pueden ser por Whatsapp, o sms
      Tambien puede optimizarse seteando un Timer a la hora exacta de la clase
      en vez de buscar cada minuto
    */

    /* var intervalID = window.setInterval(() => {
      this.buscarClaseActual()
    }, 60000); */

    try {
      //Se pone en bloque try porque genera error en Safari Mobile
      Vue.notification.requestPermission()
    } catch (e) {
      console.log("Error solicitando permisos de notificacion")
      console.log(e)
    }
  },
  created() {
    //Necesario para las actualizaciones de la aplicacion
    //Ejecuta el evento updateAvailable cuando se encuentre actualizaciones
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
  },

  beforeDestroy() {
    // Limpiar listener de evento reload-notifications
    this.$root.$off('reload-notifications', this.onReloadNotifications)
    this.$root.$off('request-banner-display', this.requestBannerDisplay)
    clearTimeout(this.bannerDisplayTimer)
  },

  updated() {
    /*
    ESTE SE EJECUTA CADA VEZ QUE EL MODELO (DATA) SE ACTUALIZA
    POR ESO NO SE DEBE ACTUALIZAR DESDE EL MISMO METODO POR QUE ENTRARIA EN UN CICLO INFINITO
    */
  },

  watch: {
    mensajes: {
      handler(newMensajes) {
        newMensajes.forEach(mensaje => {
          if (mensaje._id && !this.processedMessageIds.has(mensaje._id)) {
            // Marcar como procesado
            this.processedMessageIds.add(mensaje._id);
            // Solo auto-cerrar si autoDismiss está activo
            if (mensaje.autoDismiss) {
              const dismissTime = mensaje.dismissTime || 3000;
              const cerrarMensaje = () => {
                // Durante el recorrido los mensajes están ocultos: se reprograma para que se vean al terminar
                if (this.recorridoActivo) {
                  setTimeout(cerrarMensaje, dismissTime);
                  return;
                }
                // Buscar el índice actual del mensaje usando su ID único
                const currentIndex = this.mensajes.findIndex(m => m._id === mensaje._id);
                if (currentIndex !== -1) {
                  this.dismissMensaje(currentIndex);
                  // Limpiar el ID del Set después de cerrar el mensaje
                  this.processedMessageIds.delete(mensaje._id);
                }
              };
              setTimeout(cerrarMensaje, dismissTime);
            }
          }
        });
      },
      deep: false
    },
    logged(value) {
      // Al cerrar sesión se descarta cualquier banner pendiente de la sesión anterior
      if (!value) {
        this.bannerPending = false
        clearTimeout(this.bannerDisplayTimer)
        this.bannerDisplayTimer = null
        this.bannerHideDialog()
      }
    },
    bannerBlocked(blocked) {
      if (blocked) {
        clearTimeout(this.bannerDisplayTimer)
        this.bannerDisplayTimer = null
        if (this._bannerDialogShowed) {
          // Si se bloqueó por cerrar sesión, el banner no queda pendiente
          this.bannerPending = this.logged
          this.bannerHideDialog()
        }
        return
      }

      this.showPendingBanner()
    }
  },

  methods: {
    ...mapActions({
      setWarning: 'setWarning',
      verificarAceptacionTerminos: 'academico/verificarAceptacionTerminos',
      verificarMensajes: 'auth/verificarMensajes',
      verificarVariables: 'student/verificarVariables',
      fetchCursoActual: 'academico/fetchCursoActual', //
      fetchTipos: 'academico/fetchTipos', //
      fetchSedeActual: 'academico/fetchSedeActual', //
      fetchBanners: 'banner/fetchBanners', //
      fetchSedes: 'sedes/fetchLista',
      fetchNotificaciones: 'notificaciones/fetchNotificaciones',
    }),
    ...mapMutations({
      bannerShowDialog: 'banner/showDialog',
      bannerHideDialog: 'banner/hideDialog',
      reiniciarModalError: 'reiniciarModalError',
      removeMensaje: 'auth/removeMensaje'
    }),

    buscarClaseActual() {
      let tiempoActual = new Date()
      tiempoActual.setSeconds(0)
      tiempoActual = new Date(tiempoActual.getTime() + 60000)
      let texto = '';

      if (tiempoActual.getHours() > 5 &&
        (tiempoActual.getMinutes() == 0 || tiempoActual.getMinutes() == 30)) {

        let claseProxima = this.clases.find((element) => {
          let fecha_bloque = new Date(element.fecha_bloque)
          return element.estado == 'asignado' && tiempoActual.toString() == fecha_bloque.toString()
        })

        if (claseProxima && claseProxima.estado == 'asignado') {
          var options = { hour: 'numeric', minute: 'numeric' };
          let time = new Date(claseProxima.fecha_bloque)
          texto = time.toLocaleString('es-CO', options)

          if (claseProxima.clase && claseProxima.clase.salon) {
            texto += " en " + claseProxima.clase.salon.nombre
          }
          this.notify(texto)
        }
        this.notify(texto)
      }
    },
    notify(value) {

      if (this.show_notification) {
        this.$notification.show('Tienes clase!', {
          body: value,
          vibrate: [200, 100, 200, 100, 200, 100, 200],
          badge: '/icon/android-chrome-192x192.png',
          icon: '/icon/android-chrome-192x192.png'
        }, {})
      }

    },
    reload() {
      window.location.reload(true);
    },
    updateAvailable(event) {
      this.registration = event.detail
      this.updateExists = true
    },
    refreshApp() {
      this.updateExists = false

      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return

      //Permite la actualizacion del service worker
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })

      //Recarga la aplicacion
      window.location.reload(true);
    },
    dismissMensaje(index) {
      this.removeMensaje(index);
    },
    requestBannerDisplay() {
      this.bannerPending = true
      this.showPendingBanner()
    },
    showPendingBanner() {
      if (!this.bannerPending || this.bannerBlocked || this.bannerDisplayTimer) return

      this.bannerDisplayTimer = setTimeout(() => {
        this.bannerDisplayTimer = null
        if (!this.bannerPending || this.bannerBlocked) return

        this.bannerPending = false
        this.bannerShowDialog()
      }, 350)
    },
    onReloadNotifications() {
      // Recargar notificaciones (puede ser llamado desde cualquier evento)
      if (this.logged) {
        this.fetchNotificaciones({ page: 1, perPage: 10 })
      }
    }
  },
  computed: {
    ...mapState({
      clases: state => state.academico.clases,
      isDebug: state => state.isDebug,
      processing: state => state.processing,
      packageVersion: state => state.packageVersion,
      baseUrl: state => state.baseUrl,
      nodeEnv: state => state.nodeEnv,
      appInstance: state => state.appInstance,
      error: state => state.error,
      modal_error: state => state.modal_error,
      show_modal_error: state => state.show_modal_error,
      warning: state => state.warning,

      show_notification: state => state.show_notification,
      logged: state => state.auth.logged,
      mensajes: state => state.auth.mensajes,
      recorridoActivo: state => state.auth.recorridoActivo,
      cursoActual: state => state.academico.cursoActual, //
      tipos: state => state.academico.tipos, //
      sedeActual: state => state.academico.sedeActual, //
      user: state => state.auth.user, //
      banners: state => state.banner.banners, //
      _bannerDialogShowed: state => state.banner.bannerDialogShowed, //
      sedes: state => state.sedes.lista,
    }),

    ...mapGetters({
      recorridoPendiente: 'auth/recorridoPendiente',
      encuestaBloqueante: 'encuestaSatisfaccion/navegacionBloqueada'
    }),

    // El recorrido solo se muestra en Inicio; allí el banner espera a que termine
    recorridoBloqueaBanner() {
      return this.recorridoPendiente && ['home', 'home_index'].includes(this.$route.name)
    },

    bannerBlocked() {
      return this.processing || !!this.error || !!this.warning ||
        this.mensajes.length > 0 ||
        (this.show_modal_error && !!this.modal_error) ||
        this.updateExists ||
        this.recorridoBloqueaBanner ||
        // Con una encuesta obligatoria pendiente el estudiante debe responderla primero
        this.encuestaBloqueante ||
        // Nunca en el login ni sin sesión iniciada
        !this.logged || this.$route.name === 'login'
    },

    ultimo_banner() {
      if (this.banners.length > 0) {
        return this.banners[0]
      }
      return null
    },
    bannerDialogShowed: {
      get() {
        return this._bannerDialogShowed
      },
      set(value) {
        if (value) {
          this.bannerShowDialog()
        } else {
          this.bannerHideDialog()
        }
      }
    }
  }

}
</script>


<style>
/* Variables Globales de Tema */
:root {
  /* Colores corporativos fijos */
  --app-header-bg: #1a2332;
  --app-header-text: #ffffff;
  --app-primary-blue: #0D4E8C;
  --app-primary-red: #BC2336;
  --app-primary-yellow: #f1c400;

  /* Colores auxiliares para UI */
  --app-color-cyan: #4FACFE;
  --app-color-cyan-light: #4A8FC4;
  --app-color-green-muted: #52745C;
  --app-color-green-dark: #365744;
  --app-color-gold: #ff9500;
  --app-color-green: #059669;
  --app-color-green-light: #10b981;
  --app-color-red-bright: #ff3b30;
  --app-color-red-light: #ff6b6b;
  --app-color-pink: #f093fb;
  --app-color-pink-dark: #f5576c;
  --app-color-peach: #fa709a;
  --app-color-yellow-light: #fee140;
  --app-color-purple: #8a5eff;

  /* Tipografía global */
  --app-font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;

  /* Variables de tema - Oscuro por defecto */
  --theme-header-bg: var(--app-header-bg);
  --theme-text-primary: #ffffff;
  --theme-text-secondary: #e8e8f0;
  --theme-text-muted: #b0b0c8;

  --theme-bg-primary: #0f0f1e;
  --theme-bg-secondary: #1a1a2e;
  --theme-bg-tertiary: #16213e;
  --theme-bg-card: rgba(255, 255, 255, 0.05);
  --theme-bg-card-hover: rgba(255, 255, 255, 0.08);

  /* Bordes y líneas */
  --theme-border-color: rgba(255, 255, 255, 0.1);
  --theme-border-color-light: rgba(255, 255, 255, 0.05);
  --theme-border-color-strong: rgba(255, 255, 255, 0.2);

  /* Sombras */
  --theme-shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.1);
  --theme-shadow-md: 0 8px 24px rgba(0, 0, 0, 0.15);
  --theme-shadow-lg: 0 16px 48px rgba(0, 0, 0, 0.2);
  --theme-shadow-xl: 0 20px 60px rgba(0, 0, 0, 0.3);

  /* Overlays y backdrops */
  --theme-overlay-bg: rgba(15, 15, 30, 0.85);
  --theme-backdrop-blur: blur(10px);

  /* Estados interactivos */
  --theme-hover-bg: rgba(255, 255, 255, 0.1);
  --theme-hover-bg-light: rgba(255, 255, 255, 0.05);
  --theme-active-bg: rgba(255, 255, 255, 0.15);

  /* Gradientes */
  --theme-gradient-primary: linear-gradient(135deg, var(--app-primary-blue) 0%, #005a9e 100%);
  --theme-gradient-secondary: linear-gradient(135deg, var(--app-color-green) 0%, var(--app-color-green-light) 100%);
  --theme-gradient-success: linear-gradient(135deg, var(--app-color-cyan-light) 0%, var(--app-color-cyan) 100%);
  --theme-gradient-warning: linear-gradient(135deg, var(--app-primary-red) 0%, var(--app-color-red-bright) 100%);
  --theme-gradient-yellow: linear-gradient(135deg, var(--app-primary-yellow) 0%, var(--app-color-gold) 100%);
  --theme-gradient-purple: linear-gradient(135deg, var(--app-color-purple) 0%, var(--app-color-cyan-light) 100%);
  --theme-gradient-bg: linear-gradient(135deg, #0f0f1e 0%, #1a1a2e 50%, #16213e 100%);

  /* Gradientes de progreso (horizontales) */
  --theme-gradient-progress-success: linear-gradient(135deg, var(--app-primary-blue) 0%, var(--app-color-cyan) 100%);
  --theme-gradient-progress-yellow: linear-gradient(90deg, var(--app-primary-yellow) 0%, var(--app-color-gold) 100%);
  --theme-gradient-progress-danger: linear-gradient(90deg, var(--app-color-red-bright) 0%, var(--app-color-red-light) 100%);
  --theme-gradient-progress-green: linear-gradient(90deg, var(--app-color-green) 0%, var(--app-color-green-light) 100%);

  /* Efectos radiantes */
  --theme-radial-primary: radial-gradient(circle at 20% 50%, rgba(13, 78, 140, 0.1) 0%, transparent 50%);
  --theme-radial-secondary: radial-gradient(circle at 80% 80%, rgba(0, 90, 158, 0.1) 0%, transparent 50%);
  --theme-radial-accent: radial-gradient(circle at 40% 20%, rgba(75, 192, 254, 0.08) 0%, transparent 50%);

  /* Navegación específica */
  --theme-nav-text: #ffffff;
  --theme-nav-text-secondary: rgba(255, 255, 255, 0.8);
  --theme-nav-hover: rgba(13, 78, 140, 0.2);
  --theme-nav-active: linear-gradient(135deg, #0D4E8C 0%, #005a9e 100%);
  --theme-nav-border: rgba(255, 255, 255, 0.1);

  /* Inputs y forms */
  --theme-input-bg: rgba(255, 255, 255, 0.05);
  --theme-input-border: rgba(255, 255, 255, 0.1);
  --theme-input-focus: rgba(13, 78, 140, 0.3);

  /* Estados de color */
  --theme-color-success: var(--app-color-green);
  --theme-color-success-light: var(--app-color-green-light);
  --theme-color-danger: var(--app-color-red-bright);
  --theme-color-danger-light: var(--app-color-red-light);
  --theme-color-info: var(--app-color-cyan-light);
  --theme-color-warning: var(--app-color-gold);

  /* Variantes RGBA para bordes y efectos */
  --theme-color-pink-alpha-40: rgba(240, 147, 251, 0.4);
  --theme-color-cyan-alpha-40: rgba(79, 172, 254, 0.4);
  --theme-color-peach-alpha-40: rgba(250, 112, 154, 0.4);
  --theme-color-purple-alpha-40: rgba(138, 94, 255, 0.4);

  --theme-color-cyan-alpha-30: rgba(79, 172, 254, 0.3);

  --theme-color-pink-alpha-20: rgba(240, 147, 251, 0.2);
  --theme-color-pink-dark-alpha-20: rgba(245, 87, 108, 0.2);
  --theme-color-cyan-alpha-20: rgba(79, 172, 254, 0.2);
  --theme-color-cyan-dark-alpha-20: rgba(0, 242, 254, 0.2);
  --theme-color-peach-alpha-20: rgba(250, 112, 154, 0.2);
  --theme-color-yellow-alpha-20: rgba(254, 225, 64, 0.2);
  --theme-color-purple-alpha-20: rgba(138, 94, 255, 0.2);
}

/* Tema Claro */
html.light-theme {
  --theme-header-bg: var(--app-primary-blue);
  --theme-text-primary: #1a1a2e;
  --theme-text-secondary: #4a4a68;
  --theme-text-muted: #6b6b8c;

  --theme-bg-primary: #f5f7fa;
  --theme-bg-secondary: #ffffff;
  --theme-bg-tertiary: #e8ecf1;
  --theme-bg-card: rgba(255, 255, 255, 0.95);
  --theme-bg-card-hover: rgba(255, 255, 255, 1);

  /* Bordes y líneas */
  --theme-border-color: rgba(0, 0, 0, 0.1);
  --theme-border-color-light: rgba(0, 0, 0, 0.05);
  --theme-border-color-strong: rgba(0, 0, 0, 0.15);

  /* Sombras */
  --theme-shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --theme-shadow-md: 0 8px 24px rgba(0, 0, 0, 0.12);
  --theme-shadow-lg: 0 16px 48px rgba(0, 0, 0, 0.15);
  --theme-shadow-xl: 0 20px 60px rgba(0, 0, 0, 0.2);

  /* Overlays y backdrops */
  --theme-overlay-bg: rgba(0, 0, 0, 0.5);
  --theme-backdrop-blur: blur(10px);

  /* Estados interactivos */
  --theme-hover-bg: rgba(255, 255, 255, 0.2);
  --theme-hover-bg-light: rgba(255, 255, 255, 0.1);
  --theme-active-bg: rgba(255, 255, 255, 0.3);

  /* Gradientes (mantienen colores pero ajustan opacidad) */
  --theme-gradient-primary: linear-gradient(135deg, var(--app-primary-blue) 0%, #005a9e 100%);
  --theme-gradient-secondary: linear-gradient(135deg, var(--app-color-green) 0%, var(--app-color-green-light) 100%);
  --theme-gradient-success: linear-gradient(135deg, var(--app-color-cyan-light) 0%, var(--app-color-cyan) 100%);
  --theme-gradient-warning: linear-gradient(135deg, var(--app-color-peach) 0%, var(--app-color-yellow-light) 100%);
  --theme-gradient-yellow: linear-gradient(135deg, var(--app-primary-yellow) 0%, var(--app-color-gold) 100%);
  --theme-gradient-bg: linear-gradient(135deg, var(--theme-bg-primary) 0%, var(--theme-bg-tertiary) 50%, #dfe3e8 100%);

  /* Efectos radiantes más sutiles */
  --theme-radial-primary: radial-gradient(circle at 20% 50%, rgba(13, 78, 140, 0.05) 0%, transparent 50%);
  --theme-radial-secondary: radial-gradient(circle at 80% 80%, rgba(0, 90, 158, 0.05) 0%, transparent 50%);
  --theme-radial-accent: radial-gradient(circle at 40% 20%, rgba(75, 192, 254, 0.04) 0%, transparent 50%);

  /* Navegación específica para tema claro */
  --theme-nav-text: #ffffff;
  --theme-nav-text-secondary: rgba(255, 255, 255, 0.9);
  --theme-nav-hover: rgba(255, 255, 255, 0.2);
  --theme-nav-active: rgba(255, 255, 255, 0.2);
  --theme-nav-border: rgba(255, 255, 255, 0.2);

  /* Inputs y forms */
  --theme-input-bg: rgba(0, 0, 0, 0.03);
  --theme-input-border: rgba(0, 0, 0, 0.1);
  --theme-input-focus: rgba(13, 78, 140, 0.2);
}

/* Tema Oscuro (redundante pero explícito) */
html.dark-theme {
  --theme-header-bg: var(--app-header-bg);
  --theme-text-primary: #ffffff;
  --theme-text-secondary: #e8e8f0;
  --theme-bg-primary: #0f0f1e;
  --theme-bg-secondary: #1a1a2e;
}

/* Forzar estilos de opciones de select en tema oscuro */
html.dark-theme select option {
  background-color: #1a1a2e !important;
  color: #ffffff !important;
}

html.dark-theme select option:checked {
  background-color: var(--app-primary-blue) !important;
  color: #ffffff !important;
}

html.dark-theme select option:hover {
  background-color: #2a2a3e !important;
  color: #ffffff !important;
}

html.dark-theme select option:disabled {
  background-color: #1a1a2e !important;
  color: #8a8a9e !important;
}

/* Forzar estilos de opciones de select en tema claro */
html.light-theme select option {
  background-color: #ffffff !important;
  color: #2c2c2c !important;
}

html.light-theme select option:checked {
  background-color: var(--app-primary-blue) !important;
  color: #ffffff !important;
}

html.light-theme select option:hover {
  background-color: #f5f5f5 !important;
  color: #2c2c2c !important;
}

html.light-theme select option:disabled {
  background-color: #ffffff !important;
  color: #999999 !important;
}

/* Forzar estilos de autocomplete vue-typeahead en tema oscuro */
html.dark-theme .vbt-autcomplete-list {
  background: #1a1a2e !important;
  background-color: #1a1a2e !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

html.dark-theme .vbt-autcomplete-list .vbst-item {
  background: #1a1a2e !important;
  background-color: #1a1a2e !important;
  color: #ffffff !important;
  border-bottom-color: rgba(255, 255, 255, 0.08) !important;
}

html.dark-theme .vbt-autcomplete-list .vbst-item:hover,
html.dark-theme .vbt-autcomplete-list .vbst-item.vbst-highlighted {
  background: #2a2a3e !important;
  background-color: #2a2a3e !important;
  color: #ffffff !important;
}

html.dark-theme .vbt-autcomplete-list .vbst-item.active {
  background: var(--app-primary-blue) !important;
  background-color: var(--app-primary-blue) !important;
  color: #ffffff !important;
}

/* Forzar estilos de autocomplete vue-typeahead en tema claro */
html.light-theme .vbt-autcomplete-list {
  background: #ffffff !important;
  background-color: #ffffff !important;
  border-color: rgba(0, 0, 0, 0.15) !important;
}

html.light-theme .vbt-autcomplete-list .vbst-item {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #2c2c2c !important;
  border-bottom-color: rgba(0, 0, 0, 0.08) !important;
}

html.light-theme .vbt-autcomplete-list .vbst-item:hover,
html.light-theme .vbt-autcomplete-list .vbst-item.vbst-highlighted {
  background: #f5f5f5 !important;
  background-color: #f5f5f5 !important;
  color: #2c2c2c !important;
}

html.light-theme .vbt-autcomplete-list .vbst-item.active {
  background: var(--app-primary-blue) !important;
  background-color: var(--app-primary-blue) !important;
  color: #ffffff !important;
}

/* Input del autocomplete en tema oscuro */
html.dark-theme .vbt-autcomplete-list input,
html.dark-theme input.vbTypeahead {
  background: #1a1a2e !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
}

html.dark-theme .vbt-autcomplete-list input:focus,
html.dark-theme input.vbTypeahead:focus {
  background: #1a1a2e !important;
  border-color: var(--app-primary-blue) !important;
  color: #ffffff !important;
}

/* Input del autocomplete en tema claro */
html.light-theme .vbt-autcomplete-list input,
html.light-theme input.vbTypeahead {
  background: #ffffff !important;
  border-color: rgba(0, 0, 0, 0.2) !important;
  color: #2c2c2c !important;
}

html.light-theme .vbt-autcomplete-list input:focus,
html.light-theme input.vbTypeahead:focus {
  background: #ffffff !important;
  border-color: var(--app-primary-blue) !important;
  color: #2c2c2c !important;
}

/* Aplicar fuente global */
html,
body {
  font-family: var(--app-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--theme-bg-primary);
  color: var(--theme-text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

#app {
  font-family: var(--app-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--theme-text-primary);
  background: var(--theme-bg-primary);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Asegurar que el router-view ocupe el espacio disponible */
#app>div:not(.modern-alerts-container) {
  flex: 1 0 auto;
}

/* CONTENT CONTAINER */
.content-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.bg-red {
  background-color: var(--app-primary-red);
}

.bg-blue {
  background-color: var(--app-primary-blue) !important;
}

hr {
  border: 1px solid #E33A2D !important;
  width: 100%;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.85;
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Alertas Modernas */
.modern-alerts-container {
  position: fixed;
  top: 80px;
  right: 1rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 500px;
  width: calc(100% - 2rem);
  pointer-events: none;
}

/* Mientras el recorrido guiado está activo, los mensajes no se muestran */
.modern-alerts-container.alerts-hidden {
  display: none;
}

.modern-alert {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.95) 0%, rgba(22, 33, 62, 0.95) 100%);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05);
  pointer-events: auto;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.modern-alert::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  transition: all 0.3s ease;
}

.modern-alert:hover {
  transform: translateX(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1);
}

/* Variantes de Alerta */
.modern-alert.alert-success::before {
  background: linear-gradient(180deg, #4cd964 0%, #5de24e 100%);
}

.modern-alert.alert-success .alert-icon {
  background: rgba(76, 217, 100, 0.15);
  color: #4cd964;
}

.modern-alert.alert-danger::before {
  background: linear-gradient(180deg, #ff3b30 0%, #ff6b6b 100%);
}

.modern-alert.alert-danger .alert-icon {
  background: rgba(255, 59, 48, 0.15);
  color: #ff3b30;
}

.modern-alert.alert-warning::before {
  background: linear-gradient(180deg, #ff9500 0%, #ffb340 100%);
}

.modern-alert.alert-warning .alert-icon {
  background: rgba(255, 149, 0, 0.15);
  color: #ff9500;
}

.modern-alert.alert-info::before {
  background: linear-gradient(180deg, #0D4E8C 0%, #005a9e 100%);
}

.modern-alert.alert-info .alert-icon {
  background: rgba(13, 78, 140, 0.15);
  color: #0D4E8C;
}

.modern-alert.alert-primary::before {
  background: linear-gradient(180deg, #007aff 0%, #0051d5 100%);
}

.modern-alert.alert-primary .alert-icon {
  background: rgba(0, 122, 255, 0.15);
  color: #007aff;
}

/* Elementos de la Alerta */
.alert-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.modern-alert:hover .alert-icon {
  transform: scale(1.05);
}

.alert-content {
  flex: 1;
  min-width: 0;
  color: #ffffff;
  font-size: 0.95rem;
  line-height: 1.6;
}

.alert-content p {
  margin: 0;
}

.alert-content strong {
  font-weight: 600;
  color: #ffffff;
}

.alert-content a {
  color: #0D4E8C;
  text-decoration: underline;
  transition: all 0.2s ease;
}

.alert-content a:hover {
  color: #005a9e;
}

.alert-close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(255, 255, 255, 0.6);
}

.alert-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  transform: rotate(90deg);
}

/* Animaciones de Transición */
.alert-slide-enter-active {
  animation: slideInRight 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.alert-slide-leave-active {
  animation: slideOutRight 0.3s cubic-bezier(0.4, 0, 1, 1);
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOutRight {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  to {
    opacity: 0;
    transform: translateX(calc(100% + 2rem));
  }
}

/* Responsive para Móviles */
@media (max-width: 768px) {

  .content-container {
    padding: 1rem;
  }

  .modern-alerts-container {
    top: 70px;
    right: 0.75rem;
    left: 0.75rem;
    width: calc(100% - 1.5rem);
    max-width: none;
  }

  .modern-alert {
    padding: 1rem;
    gap: 0.75rem;
  }

  .alert-icon {
    width: 40px;
    height: 40px;
  }

  .alert-content {
    font-size: 0.9rem;
  }

  .alert-close {
    width: 28px;
    height: 28px;
  }
}

@media (max-width: 480px) {
  .modern-alerts-container {
    top: 65px;
  }

  .modern-alert {
    padding: 0.875rem;
    gap: 0.625rem;
  }

  .alert-icon {
    width: 36px;
    height: 36px;
  }

  .alert-icon svg {
    width: 20px;
    height: 20px;
  }

  .alert-content {
    font-size: 0.85rem;
  }

  .alert-close {
    width: 26px;
    height: 26px;
  }

  .alert-close svg {
    width: 16px;
    height: 16px;
  }
}

/* Tema Claro para Alertas */
html.light-theme .modern-alert {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(245, 247, 250, 0.95) 100%);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05);
}

html.light-theme .alert-content {
  color: #1a1a2e;
}

html.light-theme .alert-content strong {
  color: #1a1a2e;
}

html.light-theme .alert-close {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.6);
}

html.light-theme .alert-close:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #1a1a2e;
}

/* Estilos para Modal Moderno de Error */
#modalError .modal-content {
  background: var(--theme-bg-card) !important;
  backdrop-filter: blur(20px);
  border: 1px solid var(--theme-border-color) !important;
  border-radius: 20px !important;
  box-shadow: var(--theme-shadow-xl) !important;
  font-family: var(--app-font-family) !important;
}

#modalError .modal-header {
  background: var(--theme-bg-secondary) !important;
  border-bottom: 1px solid var(--theme-border-color) !important;
  border-radius: 20px 20px 0 0 !important;
  padding: 1.25rem 1.5rem !important;
}

#modalError .modal-title {
  color: var(--theme-text-primary) !important;
  font-weight: 700;
  font-family: var(--app-font-family);
}

#modalError .modal-body {
  padding: 1.5rem !important;
  color: var(--theme-text-primary) !important;
}

#modalError .modal-body p {
  color: var(--theme-text-primary) !important;
  line-height: 1.6;
}

#modalError .modal-footer {
  background: var(--theme-bg-secondary) !important;
  border-top: 1px solid var(--theme-border-color) !important;
  border-radius: 0 0 20px 20px !important;
  padding: 1rem 1.5rem !important;
}

#modalError .modal-footer .btn {
  padding: 0.625rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  font-family: var(--app-font-family);
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

#modalError .modal-footer .btn-primary {
  background: var(--theme-gradient-primary) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.3);
}

#modalError .modal-footer .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(13, 78, 140, 0.4) !important;
}

/* Estilos para Modal de Actualización */
#modalupgrading .modal-content {
  background: var(--theme-bg-card) !important;
  backdrop-filter: blur(20px);
  border: 1px solid var(--theme-border-color) !important;
  border-radius: 24px !important;
  box-shadow: var(--theme-shadow-xl) !important;
  font-family: var(--app-font-family) !important;
  padding: 2rem;
}

#modalupgrading .modal-body {
  padding: 0 !important;
}

.update-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.update-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, rgba(13, 78, 140, 0.15) 0%, rgba(0, 90, 158, 0.15) 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--app-primary-blue);
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.update-content h5 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
  letter-spacing: -0.02em;
}

.update-content p {
  font-size: 1rem;
  color: var(--theme-text-secondary);
  margin: 0;
  line-height: 1.6;
  max-width: 350px;
}

.btn-update {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 2rem !important;
  background: var(--theme-gradient-primary) !important;
  border: none !important;
  border-radius: 12px !important;
  color: white !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.3);
  margin-top: 0.5rem;
}

.btn-update:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(13, 78, 140, 0.4) !important;
  color: white !important;
}

.btn-update svg {
  animation: spin 3s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Estilos para Modal de Banners */
#modalBanners .modal-content {
  background: var(--theme-bg-card) !important;
  backdrop-filter: blur(20px);
  border: 1px solid var(--theme-border-color) !important;
  border-radius: 20px !important;
  box-shadow: var(--theme-shadow-xl) !important;
  overflow: hidden;
}

#modalBanners .modal-body {
  padding: 0 !important;
}

.banner-content {
  position: relative;
  display: flex;
  flex-direction: column;
}

.btn-close-banner {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-close-banner:hover {
  background: rgba(0, 0, 0, 0.7);
  transform: rotate(90deg);
  border-color: rgba(255, 255, 255, 0.2);
}

.banner-image-link,
.banner-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 20px 20px 0 0;
  transition: all 0.3s ease;
}

.banner-image-link:hover .banner-image {
  transform: scale(1.02);
}

.banner-footer {
  padding: 1.5rem;
  background: var(--theme-bg-secondary);
  border-top: 1px solid var(--theme-border-color);
  display: flex;
  justify-content: center;
}

.btn-banner-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: var(--theme-gradient-primary);
  border: none;
  border-radius: 10px;
  color: white !important;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.3);
}

.btn-banner-info:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(13, 78, 140, 0.4);
  color: white !important;
  text-decoration: none;
}

/* ============================================================================
   REMIX ICON - TAMAÑOS GLOBALES
   ============================================================================ */

/* Tamaños estándar para iconos de Remix */
i[class^="ri-"],
i[class*=" ri-"] {
  font-size: 1.25rem;
  /* 20px - tamaño por defecto */
  line-height: 1;
  vertical-align: middle;
}

/* Tamaños específicos */
.title-icon {
  font-size: 2rem !important;
  /* 32px */
}

.header-icon {
  font-size: 1.75rem !important;
  /* 28px */
}

.alert-icon i {
  font-size: 1.5rem !important;
  /* 24px */
}

.btn-refresh i,
.btn-notification i,
.info-label i,
.form-label-modern i,
.horario-time i,
.detail-row>i,
.section-label i {
  font-size: 1.125rem !important;
  /* 18px */
}

.btn-programar i,
.btn-card-collapse i,
.radio-content i {
  font-size: 1rem !important;
  /* 16px */
}

.instruction-icon i {
  font-size: 1.5rem !important;
  /* 24px */
}

.confirmation-icon i {
  font-size: 1.875rem !important;
  /* 30px */
}

.success-icon i {
  font-size: 2rem !important;
  /* 32px */
}

.no-options-icon i {
  font-size: 3rem !important;
  /* 48px - para modalNoHaySegundaOpcion */
}

.update-icon i {
  font-size: 3rem !important;
  /* 48px */
}

.btn-close-banner i,
.alert-close i {
  font-size: 1.25rem !important;
  /* 20px */
}

/* Asegurar que los iconos mantienen su aspecto */
i[class^="ri-"],
i[class*=" ri-"] {
  display: inline-block;
}

/* Iconos en navegación */
.nav-link i,
.icon-btn i {
  font-size: 1.125rem !important;
  /* 18px */
}

.notification-icon i {
  font-size: 1.25rem !important;
  /* 20px */
}

.notification-empty i {
  font-size: 3rem !important;
  /* 48px */
  opacity: 0.3;
}

.theme-toggle-btn i {
  font-size: 1.25rem !important;
  /* 20px */
}

.chevron {
  font-size: 1rem !important;
  /* 16px */
}

/* Iconos de redes sociales en Footer */
.social-icon i {
  font-size: 1.25rem !important;
  /* 20px */
}

/* Iconos en Login */
.user-icon-circle i {
  font-size: 3rem !important;
  /* 48px */
}

/* Iconos en ModernLoader */
.spinner-logo i {
  font-size: 2rem !important;
  /* 32px */
}

/* Animación para iconos en botones */
.rotating i {
  animation: rotation 1s linear infinite;
}

.btn-update i {
  animation: spin 3s linear infinite;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
